<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>

    <!-- Filter Controls -->
    <div class="row" style="padding-bottom: 25px;">
      <div class="col-md-3">
        <label for="employeeType" style="font-weight: 500; margin-bottom: 5px;">Employee Type:</label>
        <select id="employeeType" class="form-control" [(ngModel)]="selectedEmployeeType">
          <option value="">Select Employee Type</option>
          <option *ngFor="let type of employeeTypes" [value]="type">{{type}}</option>
        </select>
      </div>

      <div class="col-md-3">
        <label for="month" style="font-weight: 500; margin-bottom: 5px;">Month:</label>
        <select id="month" class="form-control" [(ngModel)]="selectedMonth">
          <option *ngFor="let month of months" [value]="month.value">{{month.name}}</option>
        </select>
      </div>

      <div class="col-md-3">
        <label for="year" style="font-weight: 500; margin-bottom: 5px;">Year:</label>
        <select id="year" class="form-control" [(ngModel)]="selectedYear">
          <option *ngFor="let year of years" [value]="year">{{year}}</option>
        </select>
      </div>

      <div class="col-md-3" style="display: flex; align-items: end;">
        <button mat-raised-button color="primary" (click)="downloadExcel()" [disabled]="!canDownload()"
          style="width: 100%;">
          <mat-icon *ngIf="!isDownloading">file_download</mat-icon>
          <mat-progress-spinner *ngIf="isDownloading" [diameter]="20" mode="indeterminate" color="primary">
          </mat-progress-spinner>
          {{isDownloading ? 'Downloading...' : 'Download Excel'}}
        </button>
      </div>
    </div>

    <!-- Validation Message -->
    <div class="row" *ngIf="selectedEmployeeType !== '' && !isValidMonthYear()" style="margin-bottom: 15px;">
      <div class="col">
        <div class="alert alert-warning" role="alert">
          <strong>Warning:</strong> Please select a month and year that is not greater than the current month and year.
        </div>
      </div>
    </div>

    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div class="row" *ngIf="is_data_available">
      <div class="col">
        <table class="table table-bordered table-striped">
          <tr style="background: #97cdef;">
            <th>S. No.</th>
            <th>Customer Code</th>
            <th>Customer Name</th>
            <th>Old Booth Code</th>
            <th>New Booth Code</th>
            <th>Changed By</th>
            <th>Changed@</th>
          </tr>
          <tr *ngFor="let data of icustomer_business_change_log_data; let log_index=index">
            <td>{{ log_index + 1 }}</td>
            <td>{{ data['icustomer_code'] }}</td>
            <td>{{ data['icustomer_name']}}</td>
            <td>{{ data['old_business_code'] }}</td>
            <td>{{ data['new_business_code'] }}</td>
            <td>{{ data['changed_by'] }}</td>
            <td>{{ data['changed_at'] | date : 'MMM d, y, h:mm a' }}</td>
          </tr>
        </table>
        <div style="font-size: 36px;" *ngIf="icustomer_business_change_log_data.length == 0">There Is No Log !!!</div>
      </div>
    </div>
  </div>
</section>